import { __assign, __spreadArrays } from "tslib";
import { pickBy } from 'shared/utils/misc';
var ParsedURL = /** @class */ (function () {
    function ParsedURL(url) {
        var _this = this;
        if (url === void 0) { url = window.location.href; }
        /**
         * Update the query parameters. If a parameter already exists, it will not be updated.
         */
        this.mergeUndefinedParams = function (params) {
            var currentKeys = Object.keys(_this.queryParams);
            var newParams = pickBy(function (_, key) { return !currentKeys.includes(key); }, params);
            _this.queryParams = Object.assign({}, _this.queryParams, newParams);
        };
        /**
         * Get a single query parameter value.
         */
        this.queryParam = function (key) {
            return _this.queryParams[key];
        };
        /**
         * Get the full URL including query parameters, hash, etc.
         */
        this.href = function () {
            var base = _this.protocol + "//" + _this.host + _this.pathname;
            var queryParamString = queryParamsToSearchString(_this.queryParams);
            return "" + base + queryParamString + _this.hash;
        };
        var parser = document.createElement('a');
        parser.href = url;
        // copies all the properties to this object
        ['host', 'hostname', 'hash', 'port', 'protocol'].forEach(function (prop) { return (_this[prop] = parser[prop]); });
        this.queryParams = queryParams(parser.search);
        // pathname is special because IE takes the "/" off the starting of pathname
        this.pathname =
            (parser.pathname.charAt(0) !== '/' ? '/' : '') + parser.pathname;
    }
    /**
     * Create and return a ParsedURL instance.
     */
    ParsedURL.of = function (url) { return new ParsedURL(url); };
    return ParsedURL;
}());
export { ParsedURL };
/**
 * Parse a URL search string into key-value pairs.
 */
var queryParams = function (urlOrSearchString) {
    if (urlOrSearchString === void 0) { urlOrSearchString = window.location.href; }
    if (urlOrSearchString.indexOf('?') !== 0) {
        return {};
    }
    try {
        // Get all non-empty query parameter pairs.
        var pairs = urlOrSearchString
            .slice(1)
            .split('&')
            .filter(Boolean);
        return pairs.reduce(function (carrier, pair) {
            var _a;
            var split = pair.split('=');
            var key = decodeURIComponent(split[0]);
            var value;
            try {
                value =
                    split.length > 1
                        ? decodeURIComponent(split[1].replace(/\+/g, ' ') || '')
                        : '';
            }
            catch (_) {
                value = split[1].replace(/\+/g, ' ') || '';
            }
            // If a key is repeated, convert it to an array.
            var finalValue = carrier[key] === undefined
                ? value
                : Array.isArray(carrier[key])
                    ? __spreadArrays(carrier[key], [value]) : [carrier[key], value];
            return __assign(__assign({}, carrier), (_a = {}, _a[key] = finalValue, _a));
        }, {});
    }
    catch (e) {
        // We don't want to halt Adapt if given a invalid user-submitted URL.
        return {};
    }
};
/**
 * Encode query param key-value pairs into a URL search string.
 */
var queryParamsToSearchString = function (queryParams) {
    return Object.keys(queryParams).length === 0
        ? ''
        : '?' +
            Object.keys(queryParams)
                .map(function (key) { return queryParamToSearchPiece(key, queryParams[key]); })
                .join('&');
};
/**
 * Convert a query param and its value to a search string piece.
 * Works when it's value is either a single value or array of values.
 */
var queryParamToSearchPiece = function (key, valueOrValues) {
    return Array.isArray(valueOrValues)
        ? valueOrValues.map(function (value) { return buildSingleValue(key, value); }).join('&')
        : buildSingleValue(key, valueOrValues);
};
/**
 * Convert a single query param and single value to a search string piece.
 */
var buildSingleValue = function (key, value) {
    return [encodeURIComponent(key), encodeURIComponent(value)].join('=');
};
